<template>
  <v-card outlined class="pa-3">
    <v-card-title class="text-subtitle-1 font-weight-bold pa-0 mb-2">
      Alunos em Busca Ativa por Risco
    </v-card-title>

    <div v-if="total === 0" class="text-center py-8 grey--text">
      <v-icon size="40" color="grey lighten-1" class="mb-2">mdi-chart-donut</v-icon>
      <div class="text-body-2">Nenhum aluno em risco de evasão neste ano letivo.</div>
    </div>

    <div v-else class="d-flex flex-wrap align-center" style="gap: 8px 24px">
      <apexchart type="donut" width="240" height="240" :options="opcoes" :series="series" />

      <div class="legenda">
        <div v-for="item of dados" :key="item.categoria" class="d-flex align-center mb-3">
          <v-icon :color="CORES_RISCO[item.categoria]" size="14" class="mr-2">mdi-circle</v-icon>
          <span class="text-body-1 flex-grow-1 mr-4">{{ item.rotulo }}</span>
          <span class="text-h6 font-weight-bold mr-1">{{ item.total }}</span>
          <span class="text-body-2 grey--text">({{ item.percentual }}%)</span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { CORES_RISCO } from "./EChipRiscoEvasao.vue";

const HEX_POR_CATEGORIA = {
  atencao: "#FFB300",
  alto_risco: "#EF6C00",
  critico: "#C62828",
};

export default {
  name: "EGraficoPorCategoria",
  props: {
    dados: { type: Array, default: () => [] },
  },
  data() {
    return { CORES_RISCO, regras: [] };
  },
  mounted() {
    this.carregarRegras();
  },
  methods: {
    async carregarRegras() {
      try {
        const { regras } = await this.$services.buscaAtivaService.regrasClassificacao();
        this.regras = regras;
      } catch (error) {
        // Sem as regras o tooltip mostra apenas a contagem.
        this.regras = [];
      }
    },
    criteriosDaCategoria(categoria) {
      return this.regras.find((regra) => regra.categoria === categoria)?.criterios ?? [];
    },
  },
  computed: {
    series() {
      return this.dados.map((item) => item.total);
    },
    total() {
      return this.series.reduce((acumulado, valor) => acumulado + valor, 0);
    },
    montarTooltip() {
      const escapar = (texto) => String(texto).replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);

      return ({ seriesIndex }) => {
        const item = this.dados[seriesIndex];
        if (!item) return "";
        const cor = HEX_POR_CATEGORIA[item.categoria] ?? "#9E9E9E";
        const criterios = this.criteriosDaCategoria(item.categoria)
          .map((criterio) => `<li>${escapar(criterio)}</li>`)
          .join("");

        return `<div class="tooltip-categoria" style="width: max-content; max-width: min(460px, 80vw); padding: 8px 12px; white-space: normal; overflow-wrap: break-word">
          <div style="font-weight: 700; color: ${cor}">
            ${escapar(item.rotulo)} — ${escapar(item.total)} (${escapar(item.percentual)}%)
          </div>
          ${criterios ? `<ul style="margin: 4px 0 0; padding-left: 16px">${criterios}</ul>` : ""}
        </div>`;
      };
    },
    opcoes() {
      return {
        chart: { type: "donut" },
        labels: this.dados.map((item) => item.rotulo),
        colors: this.dados.map((item) => HEX_POR_CATEGORIA[item.categoria] ?? "#9E9E9E"),
        legend: { show: false },
        dataLabels: { enabled: false },
        tooltip: { custom: this.montarTooltip },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: { show: true, label: "Total", fontSize: "13px" },
                value: { fontSize: "22px", fontWeight: 700 },
              },
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
/* Deixa o tooltip crescer com o conteúdo, sem ser cortado pelo contêiner do gráfico. */
::v-deep .apexcharts-canvas {
  overflow: visible !important;
}
::v-deep .apexcharts-tooltip {
  overflow: visible !important;
  width: max-content;
  max-width: none;
  z-index: 10;
}
.legenda {
  min-width: 240px;
  max-width: 300px;
}
</style>
